"use strict";

var _require = require('./index-esm'),
    uncontrollable = _require.default,
    useUncontrolled = _require.useUncontrolled;

module.exports = uncontrollable;
module.exports.useUncontrolled = useUncontrolled;
module.exports.uncontrollable = uncontrollable;